// assets/slider-fix.js
(function () {
  function getStep(slider) {
    // Try width of one slide; fallback to slider viewport width
    const slide = slider.querySelector('[class*="__slide"], [data-slide], li, .grid__item');
    const slideWidth = slide ? slide.getBoundingClientRect().width : 0;
    const viewport = slider.getBoundingClientRect().width || 0;
    // prefer a single-card step, but never 0
    return Math.max(1, Math.round(slideWidth || viewport));
  }

  function attach(btn) {
    const targetId = btn.getAttribute('aria-controls');
    if (!targetId) return;
    const slider = document.getElementById(targetId);
    if (!slider) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();

      // if theme disabled the button, do nothing
      if (btn.hasAttribute('disabled')) return;

      const step = getStep(slider);
      const dir = btn.classList.contains('slider-button--prev') ? -1 : 1;
      slider.scrollBy({ left: dir * step, behavior: 'smooth' });

      // optional: update "1/5" counter if present
      const status = slider.parentElement?.querySelector('[data-slider-status]');
      if (status) {
        const slides = slider.querySelectorAll('[class*="__slide"], [data-slide], li, .grid__item');
        if (slides.length) {
          // compute index by left edge
          const left = slider.scrollLeft + dir * step;
          const widths = Array.from(slides).map(s => s.getBoundingClientRect().width);
          const avg = widths.reduce((a,b)=>a+b,0)/widths.length;
          const index = Math.min(slides.length, Math.max(1, Math.round(left / Math.max(1, avg)) + 1));
          status.textContent = `${index}/${slides.length}`;
        }
      }
    }, { passive: false });
  }

  function init() {
    document.querySelectorAll('.slider-button').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
